<div class="mb-regular date-slider">
    <div *ngFor="let date of dates; index as i" class="date-slider-item" [attr.data-slide-index]="i">
      <input type="radio" [value]="i" (change)="onChange($event)" [checked]="dates[i] === value" name="date" [id]="'date-' + i" class="form-check-input visually-hidden">
      <label [for]="'date-' + i" class="date-slider-label">
        <span class="fw-bold">{{ date | date : 'EEEEEE' }}</span>
        <span>{{ date | date : 'dd.MM.' }}</span>
      </label>
    </div>
</div>
